export default Object.freeze({
  None: 0,
  ChildRejected: 1,
  ChildCanceled: 2,
  ChildVoided: 3,
  ChildError: 4,
  ChildFinishedWithoutTargetAction: 5,
  TargetActionError: 6,
  TargetActionNotSuccessful: 7,
});
